import React from "react";
import Slider from "react-slick";
import ProductCard from "web/react/components/product-card/react/product-card";
import { ProductCardSerializer } from "web/types/serializers";
import styles from "./related-products-rail.module.css";

interface RelatedProductsRailProps {
    products: ProductCardSerializer[];
    title: string | null;
}

function RelatedProductsRail({ products, title }: RelatedProductsRailProps): JSX.Element {
    const slickSettings = {
        arrows: true,
        draggable: false,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        swipe: false,
        touchMove: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    swipe: true,
                    touchMove: true,
                    draggable: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    swipe: true,
                    touchMove: true,
                    draggable: true,
                    arrows: false,
                },
            },
        ],
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                {title && <h5 className={styles.title}>{title}</h5>}

                <Slider className={styles.products} {...slickSettings}>
                    {products.map((product) => (
                        <div key={product.uid}>
                            <ProductCard className={styles.productCard} product={product}>
                                <ProductCard.Image
                                    width={200}
                                    height={250}
                                    analyticsEventLabel="new_similar_oos"
                                />

                                <ProductCard.Details analyticsEventLabel="new_similar_oos" />
                            </ProductCard>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
}

export default RelatedProductsRail;
